const isDev = process.env.NODE_ENV === 'development'

const isStaging = process.env.NODE_ENV === 'staging'

let DEFAULT_CONFIG = {
  CANTONESE_AUDIO_URL: 'https://cdn.static.igoldhorse.cn/static_pages/static_pages/audio/risk-cantonese.mp3',
  MANDARIN_AUDIO_URL: 'https://cdn.static.igoldhorse.cn/static_pages/static_pages/audio/risk-mandarin.mp3'
}

if (isDev || isStaging) {
  DEFAULT_CONFIG = {
    CANTONESE_AUDIO_URL: 'https://static.fwdev.ltd/static_pages/static_pages/audio/risk-cantonese.mp3',
    MANDARIN_AUDIO_URL: 'https://static.fwdev.ltd/static_pages/static_pages/audio/risk-mandarin.mp3'
  }
}

export default DEFAULT_CONFIG
